import SideBar from "components/our-services/SideBar";
import useLang from "hooks/useLang";
import { useEffect } from "react";
import { Container, Row, Col, Tab, Accordion } from "react-bootstrap";

const DiligencePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const { lang } = useLang();
  
  return (
    <Container className="text-muted" style={{ paddingTop: "2rem", marginBottom: "50px" }}>
      <h2>{lang.services.lists.list_7.title}</h2>
      <Tab.Container id="diligence-services" defaultActiveKey="first">
        <Row>
          <Row>
            <Col>
              {lang.services.lists.list_7.nav_1.paragraphs.map(l => <p>{l}</p>)}
              <Accordion defaultActiveKey={["0"]}>
                {lang.services.lists.list_7.nav_1.accordion.map(l => {
                  return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                    <Accordion.Header>{l.header}</Accordion.Header>
                    <Accordion.Body>{l.body}</Accordion.Body>
                  </Accordion.Item>
                })}
              </Accordion>
              <p style={{ marginTop: "20px" }}>
                {lang.services.lists.list_7.nav_1.why_us}
              </p>
              <Accordion defaultActiveKey={["0"]}>
                {lang.services.lists.list_7.nav_1.accordion_why.map(l => {
                  return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                    <Accordion.Header>{l.header}</Accordion.Header>
                    <Accordion.Body>{l.body}</Accordion.Body>
                  </Accordion.Item>
                })}
              </Accordion>
              <p style={{ marginTop: "20px" }}>
                {lang.services.lists.list_7.nav_1.closing_paragraph}
              </p>
            </Col>
            <SideBar />
          </Row>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default DiligencePage;
